import * as React from 'react';

const PrideSmall = () => (
  <svg
    width="124"
    height="18"
    viewBox="0 0 124 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M106.035 7.87526C111.21 7.87526 115.334 11.9296 115.334 16.8439C115.334 16.9192 115.333 16.9963 115.33 17.0737H116.645L116.648 16.8439C116.647 11.2541 112.043 6.70639 106.309 6.56574L106.035 6.56213C105.722 6.56214 105.412 6.57527 105.106 6.60099V7.91927C105.411 7.89017 105.721 7.87527 106.035 7.87526Z"
      fill="url(#paint0_linear_3366_28582)"
    />
    <path
      d="M106.035 6.56324C111.912 6.56324 116.605 11.1685 116.605 16.7625C116.605 16.8666 116.603 16.9703 116.6 17.0736H117.914L117.915 17.0598L117.918 16.7625C117.918 10.5038 112.763 5.41144 106.342 5.25373L106.035 5.25012C105.722 5.25012 105.412 5.26182 105.106 5.2848V6.60195C105.412 6.57633 105.722 6.56324 106.035 6.56324Z"
      fill="url(#paint1_linear_3366_28582)"
    />
    <path
      d="M106.035 5.25124C112.614 5.2513 117.875 10.4076 117.875 16.6812C117.875 16.8117 117.873 16.9418 117.868 17.0713H119.182L119.184 17.0104L119.189 16.6812C119.189 9.75336 113.482 4.11679 106.375 3.94232L106.035 3.93811C105.719 3.93811 105.418 3.94142 105.107 3.96271V5.27917C105.418 5.25569 105.718 5.25124 106.035 5.25124Z"
      fill="url(#paint2_linear_3366_28582)"
    />
    <path
      d="M106.035 3.93898C113.315 3.93898 119.146 9.64663 119.146 16.6003C119.146 16.7571 119.143 16.9134 119.137 17.0689H120.451C120.452 17.0329 120.453 16.9968 120.454 16.9607L120.459 16.6003C120.459 9.00308 114.201 2.82205 106.407 2.63067L106.035 2.62585C105.721 2.62585 105.41 2.63556 105.101 2.65468L105.105 3.97265C105.413 3.95177 105.721 3.93898 106.035 3.93898Z"
      fill="url(#paint3_linear_3366_28582)"
    />
    <path
      d="M106.035 2.62685C114.017 2.62686 120.416 8.8855 120.416 16.5188C120.416 16.7034 120.413 16.8871 120.405 17.07H121.719C121.721 17.0171 121.723 16.9642 121.724 16.9112L121.729 16.5188C121.729 8.25251 114.921 1.52667 106.44 1.31854L106.035 1.31372C105.719 1.31372 105.408 1.32348 105.097 1.3413L105.102 2.65385C105.413 2.63452 105.719 2.62685 106.035 2.62685Z"
      fill="url(#paint4_linear_3366_28582)"
    />
    <path
      d="M106.035 1.31313C114.719 1.31321 121.686 8.20607 121.686 16.519C121.686 16.7033 121.683 16.8868 121.676 17.0695H122.99C122.992 17.0275 122.993 16.9854 122.994 16.9433L123 16.519C123 7.5836 115.64 0.230318 106.473 0.0054162L106.035 0C105.722 0 105.407 0.00292002 105.098 0.0191824V1.33423C105.407 1.3167 105.722 1.31313 106.035 1.31313Z"
      fill="url(#paint5_linear_3366_28582)"
    />
    <g clipPath="url(#clip0_3366_28582)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.31417 12.8346L0.207031 15.0577C1.38084 16.6269 3.45227 17.8039 6.35226 17.8039C10.6332 17.8039 13.1189 15.3846 13.1189 12.1808C13.1189 10.5462 12.0832 9.56539 10.9785 8.65001L9.8737 7.66924C9.18322 7.08078 8.83798 6.62309 8.83798 6.03463C8.83798 5.25001 9.39036 4.53078 10.7023 4.53078C11.5999 4.53078 12.4975 4.8577 13.3261 5.7077L16.4332 3.48463C15.6737 2.37309 13.8785 1.19617 11.1166 1.19617C7.38798 1.19617 4.62607 3.55001 4.62607 6.62309C4.62607 8.12693 5.52369 9.17309 6.6975 10.1539L7.80227 11.1346C8.56179 11.7885 8.90703 12.1808 8.90703 12.7692C8.90703 13.5539 8.2856 14.4039 6.62846 14.4039C5.31655 14.4039 4.14275 13.8154 3.31417 12.8346ZM44.6047 12.8346L41.4975 15.0577C42.6023 16.6269 44.7427 17.8039 47.6427 17.8039C51.9237 17.8039 54.4094 15.3846 54.4094 12.1808C54.4094 10.5462 53.3737 9.56539 52.2689 8.65001L51.1642 7.66924C50.4737 7.08078 50.1285 6.62309 50.1285 6.03463C50.1285 5.25001 50.6808 4.53078 51.9927 4.53078C52.8904 4.53078 53.788 4.8577 54.6166 5.7077L57.7237 3.48463C56.9642 2.37309 55.1689 1.19617 52.407 1.19617C48.6785 1.19617 45.9166 3.55001 45.9166 6.62309C45.9166 8.12693 46.8142 9.17309 47.988 10.1539L49.0927 11.1346C49.8523 11.7885 50.1975 12.1808 50.1975 12.7692C50.1975 13.5539 49.5761 14.4039 47.9189 14.4039C46.607 14.4039 45.4332 13.8154 44.6047 12.8346ZM44.0523 4.8577H40.0475L36.3189 17.4116H32.1761L35.9046 4.8577H31.6237L32.6594 1.4577H45.157L44.0523 4.8577ZM28.8618 17.4769V1.52309H23.1308L13.188 17.4769H17.607L19.5404 14.1423H25.2023V17.4769H28.8618ZM25.2023 4.59616V10.7423H21.5427L25.2023 4.59616Z"
        fill="white"
      />
    </g>
    <path
      d="M114.165 5.08328C114.165 7.02452 112.894 8.89881 110.305 9.47895C111.198 10.0368 111.778 10.8847 111.778 12.1565C111.778 14.4771 110.082 16.9315 106.579 16.9315H98.5239L103.009 1.31238H109.68C111.912 1.31238 114.165 2.36109 114.165 5.08328ZM108.743 4.65934H106.066L105.285 7.3369H108.163C109.435 7.3369 110.171 6.68982 110.171 5.77499C110.171 4.90478 109.48 4.65934 108.743 4.65934ZM105.798 13.5846C107.271 13.5846 107.828 12.7367 107.828 11.8888C107.828 11.0409 107.293 10.5946 106.177 10.5946H104.37L103.5 13.5846H105.798Z"
      fill="#FA5333"
    />
    <path
      d="M91.0793 17.2439C86.4828 17.2439 84.8762 14.5217 85.9249 10.8624L88.6694 1.31238H92.6858L89.852 11.2417C89.4058 12.8259 90.0529 13.6292 91.3024 13.6292C92.3288 13.6292 93.1321 13.1829 93.6006 11.5318L96.546 1.31238H100.562L97.5054 12.0226C96.5683 15.258 94.6493 17.2439 91.0793 17.2439Z"
      fill="#FA5333"
    />
    <path
      d="M72.811 16.9315L77.296 1.31238H81.3123L77.8315 13.4061H84.0345L83.0081 16.9315H72.811Z"
      fill="#FA5333"
    />
    <path
      d="M64.775 17.2439C61.495 17.2439 60 15.5035 60 12.8705C60 7.89473 63.5924 1 69.9739 1C73.1647 1 74.7043 2.71811 74.9497 4.74859L70.9334 6.08738C70.7772 5.37336 70.3533 4.65934 69.3045 4.65934C66.6047 4.65934 64.2172 9.16658 64.2172 12.045C64.2172 12.9375 64.6188 13.5846 65.5113 13.5846C66.56 13.5846 67.6534 12.7144 68.5682 11.3756L72.0044 13.1829C71.1342 14.5217 68.7244 17.2439 64.775 17.2439Z"
      fill="#FA5333"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3366_28582"
        x1="105.106"
        y1="11.9769"
        x2="110.699"
        y2="11.9769"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#502E91" stopOpacity="0" />
        <stop offset="1" stopColor="#502E91" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3366_28582"
        x1="105.106"
        y1="11.2809"
        x2="110.682"
        y2="11.2809"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#336FE2" stopOpacity="0" />
        <stop offset="1" stopColor="#336FE2" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3366_28582"
        x1="105.107"
        y1="10.5851"
        x2="111.284"
        y2="10.5851"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#55A17B" stopOpacity="0" />
        <stop offset="1" stopColor="#55A17B" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3366_28582"
        x1="105.101"
        y1="9.88833"
        x2="110.682"
        y2="9.88833"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFC100" stopOpacity="0" />
        <stop offset="1" stopColor="#FFC100" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_3366_28582"
        x1="105.097"
        y1="9.19185"
        x2="110.716"
        y2="9.19185"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF621D" stopOpacity="0" />
        <stop offset="1" stopColor="#FF621D" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_3366_28582"
        x1="105.098"
        y1="8.57643"
        x2="110.699"
        y2="8.57643"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C2102A" stopOpacity="0" />
        <stop offset="1" stopColor="#C2102A" />
      </linearGradient>
      <clipPath id="clip0_3366_28582">
        <rect width="58" height="17" fill="white" transform="translate(0 1)" />
      </clipPath>
    </defs>
  </svg>
);

export default PrideSmall;
